import type { FindFn } from "@shared/models/analytics/base"
import { createBlankEvent } from "@shared/models/analytics/base"
import type { HelpSiteAccess } from "@shared/models/analytics/help-site"
import type { PreparedAction } from "@shared/actions/action-doc-builder"
import { partial } from "lodash-es"
import type { Narrative } from "@shared/actions/create-narrative"
import createNarrative from "@shared/actions/create-narrative"

interface Payload {
  articleId: string
  articleTitle: string
}

export default function visitArticleAction(payload: Payload): PreparedAction {
  return {
    name: "KB_VISIT_ARTICLE",
    payload: payload,
    patches: null,
    undoPatches: null,
    narrative: partial(narrative, payload),
  }
}

function narrative(payload: Payload, _findFn: FindFn, _userId: string): Narrative {
  let newEvent: HelpSiteAccess = {
    ...createBlankEvent(),
    root_id: "help_site",
    root_type: "app",

    primary_verb: "view",

    primary_object_type: "help_article",
    primary_object_id: payload.articleId,
    primary_object_specifier: null,
    primary_object_id_and_ancestor_ids: ["help_site", payload.articleId],
  }
  return createNarrative({
    title: "Visited an Article",
    description: `User visited the article, ${payload.articleTitle}`,
    titleForAnalytics: "KB Article - Visit",
    context: {
      articleId: payload.articleId,
      articleTitle: payload.articleTitle,
    },
    newAnalyticsEvents: [newEvent],
  })
}
